import React, { Component } from "react";
import '../rnr.css';
import Table from 'react-bootstrap/Table';
import { MathFormula } from '../libs/myUtils.js';

class Glossary extends Component {
  
  render() {
    return (
      <main className="flex-shrink-0">
        <div className="container">
            <h4 className="mt-3">Glossary</h4><br />
            <Table size="sm" borderless="true" hover>
                <tbody>
                <tr>
                        <td colSpan="2"><h4>L</h4></td>
                    </tr>
                    <tr>
                        <td style={{width: "17%"}}><strong>Loaded Premium</strong></td>
                        <td style={{width: "83%"}}>
                          <p>Discounted loaded expected loss from a pricing model:</p>
                          <MathFormula string="$$P^{loaded} = \cfrac{(1+\theta)\mathbb{E}(L)}{1\ + \ r}$$" />
                          <MathFormula string="where $\theta$ is the loading incorporating risk, expenses and profits, $L$ is a random loss, and $r$ is the discount rate." />
                        </td>
                    </tr>
                    <tr>
                        <td colSpan="2"><h4>P</h4></td>
                    </tr>
                    <tr>
                        <td style={{width: "17%"}}><strong>Pure Premium</strong></td>
                        <td style={{width: "83%"}}>
                          <p>Discounted expected loss from a pricing model:</p>
                          <MathFormula string="$$P^{pure} = \cfrac{\mathbb{E}(L)}{1\ + \ r}$$" />
                          <MathFormula string="where $L$ is a random loss, and $r$ is the discount rate." />
                        </td>
                    </tr>
                </tbody>
           </Table>
        </div>
      </main>
    );
  }
}
 
export default Glossary;